import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '../pages/private/Dashboard'
import Profile from '../pages/private/profile/Profile'
import Settings from '../pages/private/Settings'
import Users from '../pages/private/users/Users'
import CreateUser from '../pages/private/users/Create';
import ManageUser from '../pages/private/users/Manage';
import ManageUserPermissions from '../pages/private/users/manage/Permissions';
import ManageUserDetails from '../pages/private/users/manage/Details';
import ChangeUserPassword from '../pages/private/users/manage/ChangePassword';

import Public from '../pages/public/Public'
import Login from '../pages/public/Login'
import Register from '../pages/public/Register'
import Activate from '../pages/public/Activate'
import LostPassword from '../pages/public/LostPassword'
import ResetPassword from '../pages/public/ResetPassword'
import CookiePolicy from '../pages/public/CookiePolicy'

import ManagePatient from '../pages/private/patients/manage'
import ListPatient from '../pages/private/patients/list'

import ManageApplication from '../pages/private/applications/manage'
import ManageUniversalApplication from '../pages/private/applications/manage-universal'
import ListApplications from '../pages/private/applications/list'
import SelectUserApplications from '../pages/private/applications/selectUser'
import Private from '../pages/private/Private';

import Admin from '../pages/private/admin/Admin';
import AdminTranslator from '../pages/private/admin/translator/Translator';
import AdminTemplateList from '../pages/private/admin/template/List';
import AdminManageTemplateList from '../pages/private/admin/template/Manage';
import AdminEpicrisisList from '../pages/private/admin/epicrisis/List';
import AdminEpicrisisManage from '../pages/private/admin/epicrisis/Manage';
import AdminLoginAs from '../pages/private/admin/loginAs/LoginAs';
import DataExports from '../pages/private/admin/dataExports/DataExports';
import AdminMail from '../pages/private/admin/adminMail/AdminMail';
import AdminMailManage from '../pages/private/admin/adminMail/Manage';

import SubUsersList from '../pages/private/subuser/SubUsers';
import SubUserManage from '../pages/private/subuser/Manage';
import Report from '../pages/private/report/report';
import CheckPin from '../pages/private/CheckPin';
import TwoFA from '../pages/private/TwoFA'
import Documents from '../pages/private/documents/documents'
import RecoverPin from '../pages/private/RecoverPin';
import ChangePassword from '../pages/private/subuser/ChangePassword';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: {name: 'login'},
      component: Private,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard
        }, {
          path: '/patients/create/:tab',
          name: 'createPatient',
          component: ManagePatient
        }, {
          path: '/patients/edit/:id/:tab',
          name: 'managePatient',
          component: ManagePatient
        }, {
          path: '/patients/page/:page',
          name: 'patients',
          component: ListPatient
        }, {
          path: '/applications/select-user/:patientId',
          name: 'selectApplicationUser',
          component: SelectUserApplications,
        }, {
          path: '/applications/edit/:id',
          name: 'manageApplication',
          component: ManageUniversalApplication,
          // component: ManageApplication,
        }, {
          path: '/applications/edit/old/:id',
          name: 'manageApplication',
          component: ManageApplication,
          // component: ManageUniversalApplication,
        }, {
          path: '/applications/:page',
          name: 'applications',
          component: ListApplications
        }, {
          path: '/users/create',
          name: 'createUser',
          component: CreateUser,
        }, {
          path: '/admin',
          component: Admin,
          children: [
            {
              path: '',
              redirect: {name: 'adminTranslator', params: {page: 1}},
              fullMatch: true,
            }, {
              path: 'translator/:page',
              name: 'adminTranslator',
              component: AdminTranslator
            }, {
              path: 'template/:type/page/:page',
              name: 'adminTemplateList',
              component: AdminTemplateList
            }, {
              path: 'template/:type/edit/:id',
              name: 'adminEditTemplateList',
              component: AdminManageTemplateList
            }, {
              path: 'template/:type/create',
              name: 'adminCreateTemplateList',
              component: AdminManageTemplateList
            }, {
              path: 'epicrisis/page/:page',
              name: 'epicrisisList',
              component: AdminEpicrisisList
            }, {
              path: 'epicrisis/create-new',
              name: 'epicrisisCreateNew',
              component: AdminEpicrisisManage
            }, {
              path: 'epicrisis/edit/:id',
              name: 'epicrisisEdit',
              component: AdminEpicrisisManage
            }, {
              path: 'login-as',
              name: 'loginAs',
              component: AdminLoginAs
            }, {
              path: 'data-exports',
              name: 'dataExports',
              component: DataExports
            }, {
              path: 'data-exports/download/:id',
              name: 'dataExportDownload',
              component: DataExports
            }, {
              path: 'mail-admin/page/:page',
              name: 'mailAdmin',
              component: AdminMail
            }, {
              path: 'mail-admin/manage/:id',
              name: 'adminMailEdit',
              component: AdminMailManage
            },
          ]
        }, {
          path: '/user/edit/:id',
          component: ManageUser,
          children: [
            {
              path: 'manage',
              name: 'manageUserDetails',
              component: ManageUserDetails
            }, {
              path: 'permissions',
              name: 'manageUserPermissions',
              component: ManageUserPermissions
            }, {
              path: 'change-password',
              name: 'changeUserPassword',
              component: ChangeUserPassword
            }
          ]
        }, {
          path: '/users/:page',
          name: 'users',
          component: Users
        }, {
          path: '/settings',
          name: 'settings',
          component: Settings
        }, {
          path: '/profile/:type',
          name: 'profile',
          component: Profile
        }, {
          path: '/sub-users/page/:page',
          name: 'subUsersList',
          component: SubUsersList
        }, {
          path: '/sub-users/create',
          name: 'subUserCreate',
          component: SubUserManage
        }, {
          path: '/sub-users/edit/:id',
          name: 'subUserEdit',
          component: SubUserManage
        }, {
          path: '/sub-users/change-password/:id',
          name: 'changePassword',
          component: ChangePassword
        }, {
          path: '/report',
          name: 'report',
          component: Report
        }, {
          path: '/documents',
          name: 'documents',
          component: Documents
        },
      ]
    }, {
      path: '/public',
      name: 'public',
      meta: {public: true},
      component: Public,
      children: [
        {
          path: '',
          redirect: {name: 'login'}
        }, {
          path: 'login',
          name: 'login',
          meta: {public: true},
          component: Login
        }, {
          path: 'lost-password',
          name: 'lostPassword',
          meta: {public: true},
          component: LostPassword
        }, {
          path: 'cookie-policy',
          name: 'cookiePolicy',
          meta: {public: true},
          component: CookiePolicy
        }, {
          path: 'reset-password/:userId/:hash',
          name: 'resetPassword',
          meta: {public: true},
          component: ResetPassword
        }, {
          path: 'registration',
          name: 'register',
          meta: {public: true},
          component: Register
        }, {
          path: 'activate/:userId/:hash',
          name: 'activate',
          meta: {public: true},
          component: Activate
        },
        {
          path: '/account/check-pin',
          name: 'accountCheckPin',
          component: CheckPin,
        },
        {
          path: '/account/recover-pin/:recoveryHash',
          name: 'accountRecoverPin',
          component: RecoverPin,
        },
        {
          path: '/account/2fa',
          name: 'twoFactorAuth',
          component: TwoFA,
        },
      ],
    },
  ],
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/router.js